// Normalize the beta catalog before app.jsx captures it. The catalog is
// currently embedded in the bundle, so this keeps navigation deterministic
// even when records arrive from a mixed export with stale labels or order.
const CANONICAL_PARSHA_ORDER = [
  "בראשית", "נח", "לך לך", "וירא", "חיי שרה", "תולדות", "ויצא", "וישלח", "וישב", "מקץ", "ויגש", "ויחי",
  "שמות", "וארא", "בא", "בשלח", "יתרו", "משפטים", "תרומה", "תצוה", "כי תשא", "ויקהל", "פקודי", "ויקרא", "צו", "שמיני",
  "תזריע", "מצורע", "אחרי", "קדושים", "אמור", "בהר", "בחוקותי", "במדבר", "נשא", "בהעלותך", "שלח", "קרח", "חוקת", "בלק",
  "פינחס", "מטות", "מסעי", "דברים", "ואתחנן", "עקב", "ראה", "שופטים", "כי תצא", "כי תבוא", "ניצבים", "וילך", "האזינו", "וזאת הברכה",
];

const normalizeParsha = (value) => String(value || "")
  .normalize("NFKD")
  .replace(/[\u0591-\u05c7]/g, "")
  .replace(/[״׳'`.,()\[\]]/g, "")
  .replace(/\s+/g, " ")
  .trim();

const PARSHA_LOOKUP = new Map(CANONICAL_PARSHA_ORDER.map((name) => [normalizeParsha(name), name]));
PARSHA_LOOKUP.set(normalizeParsha("וילך"), "וילך");
PARSHA_LOOKUP.set(normalizeParsha("ניצבים"), "ניצבים");

function betaRefOrder(item) {
  const ref = String(item?.ref || "");
  const volume = Number(item?.volume || ref.match(/\bVol\.?\s*(\d+)/i)?.[1] || 999);
  const sicha = Number(ref.match(/\bSicha\s+(\d+)/i)?.[1] || item?.sicha || 999);
  const section = Number(ref.match(/\bSection\s+(\d+)/i)?.[1] || item?.section || 999);
  return volume * 1000000 + sicha * 1000 + section;
}

function normalizeBetaCatalog(payload) {
  if (!payload || !Array.isArray(payload.items)) return payload;
  const items = payload.items.map((item) => {
    const raw = Array.isArray(item.parshiyos) && item.parshiyos.length
      ? item.parshiyos
      : [item.parsha];
    const parshiyos = [...new Set(raw.map((name) => PARSHA_LOOKUP.get(normalizeParsha(name))).filter(Boolean))];
    return { ...item, ref: String(item.ref || "").replace(/, Section \d+(?::\d+)?$/, ", Section 1"), parsha: parshiyos[0] || "", parshiyos, order: betaRefOrder(item) };
  });
  const orders = { ...(payload.orders || {}), parsha: CANONICAL_PARSHA_ORDER };
  return { ...payload, items: items.sort((a, b) => a.order - b.order || String(a.ref || "").localeCompare(String(b.ref || ""))), orders };
}

let betaCatalog = normalizeBetaCatalog(window.MAYANOS_LIKKUTEI_SICHOS_BETA);
Object.defineProperty(window, "MAYANOS_LIKKUTEI_SICHOS_BETA", {
  configurable: true,
  get: () => betaCatalog,
  set: (value) => { betaCatalog = normalizeBetaCatalog(value); },
});
